import React, { useRef, useEffect, useState } from 'react';

import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { useHistory, useParams } from "react-router-dom";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import 'primeflex/primeflex.css';
import { InputMask } from 'primereact/inputmask';
import { ErrorValidationMessage } from './ErrorValidationMessage';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import '../layout/sass/_formEscola.scss';
import { Dropdown } from 'primereact/dropdown';
import api from '../api/api';

export const FormPessoa = ({ isEditing, isLoading }) => {
    const toast = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const history = useHistory();
    const [pessoasTipo, setPessoasTipo] = useState([]);
    const { id } = useParams();
    const [defaultValues, setDefaultValues] = useState({
        "id": 0,
        "nome": "",
        "cpfcnpj": "",
        "celular": "",
        "tipoId": 0,
        "tipoDescricao": ""
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    
    const schema = Yup.object().shape({
        nome: Yup
            .string()
            .required("O nome da pessoa é obrigatório")
            .max(200, "O nome deve ter no máximo 200 caracteres"),
        cpfcnpj: Yup
            .string()
            .required("O cpf/cnpj é obrigatório")
            .min(11, "O cpf/cnpj deve ter no mínimo 11 caracteres")
            .max(18, "O cpf/cnpj deve ter no máximo 18 caracteres"),
        tipoId: Yup
            .number()
            .required("A tipo pessoa é obrigatório")
            .positive("A tipo pessoa deve ser selecionada")
            .integer("A tipo pessoa deve estar na lista")

    })

    const formik = useFormik({
        initialValues: defaultValues,

        validationSchema: schema,

        enableReinitialize: true,

        onSubmit: async (data) => {
            setIsSubmiting(true)            

            await api.post("pessoa", data)

            try {
                if (!isEditing) {

                    formik.resetForm()
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro concluído!', detail: `Cadastro de ${data.nome} foi realizado.` });
                    setTimeout(() => {
                        history.push('/pessoa')
                    }, 2000)

                }
                else {
                    await api.put("pessoa", data)
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro atualizado!', detail: `Cadastro de ${data.nome} foi atualizado com sucesso.` });
                    setTimeout(() => {
                        history.push('/pessoa')
                    }, 2000)
                }
            }
            catch (error) {
                if (!isEditing)
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao cadastrar pessoa!', detail: error.toString() });
                else
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao editar pessoa!', detail: error.toString() });

            }

            setIsSubmiting(false)
        }
    })

    useEffect(() => {

        api.get("tipo").then((response) => { setPessoasTipo(response.data); });

        if (isEditing) {
            api.get(`pessoa/${id}`).then((response) => { setDefaultValues(response.data); });
        }

    }, [id,isEditing])

    function handleGetContribuinte(e){        

        if (!isEditing) {
            api.get(`pessoa/produtor/${e.target.value}`).then((response) => { 
                
                let temp = response.data;
                temp.observacao = "Cod Siat: " + temp.id;
                temp["tipoId"] = 0;
                temp.id = 0;                
                formik.setValues(temp);});
        }
    }

    return (
        <>
            <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
                <Toast ref={toast} position="bottom-right" />
                <div className="p-col-12">
                    <h2 className="p-mt-0">Pessoa</h2>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="p-formgrid p-grid p-fluid p-mx-0">

                        <div className="p-field p-col-12 p-sm-4 p-md-1">
                                <label
                                    htmlFor="id"
                                    className={classNames({ 'p-error': isFormFieldValid('id') })}
                                >
                                    Id
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="id"
                                            name="id"
                                            className={classNames({ 'p-invalid': isFormFieldValid('id') })}
                                            value={formik.values.id}
                                            onChange={formik.handleChange}
                                            disabled={isEditing}
                                            onBlur={handleGetContribuinte}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.id && formik.touched.id &&
                                    <ErrorValidationMessage message={formik.errors.id} />
                                }

                            </div>
                            
                            <div className="p-field p-col-12 p-sm-8 p-md-5 p-xl-4">
                                <label
                                    htmlFor="nome"
                                    className={classNames({ 'p-error': isFormFieldValid('nome') })}
                                >
                                    Nome
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="nome"
                                            name="nome"
                                            className={classNames({ 'p-invalid': isFormFieldValid('nome') })}
                                            value={formik.values.nome}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.nome && formik.touched.nome &&
                                    <ErrorValidationMessage message={formik.errors.nome} />
                                }

                            </div>

                            <div className="p-field p-col-12 p-sm-4 p-md-2">
                                <label
                                    htmlFor="cpfcnpj"
                                    className={classNames({ 'p-error': isFormFieldValid('cpfcnpj') })}
                                >
                                    CPF / CNPJ
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            // type="number"
                                            id="cpfcnpj"
                                            name="cpfcnpj"
                                            maxLength='18'
                                            className={classNames({ 'p-invalid': isFormFieldValid('cpfcnpj') })}
                                            onChange={formik.handleChange}
                                            value={formik.values.cpfcnpj}
                                            type="tel"
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.cpfcnpj && formik.touched.cpfcnpj &&
                                    <ErrorValidationMessage message={formik.errors.cpfcnpj} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-4 p-md-3 p-xl-2">
                                <label
                                    htmlFor="celular"
                                    className={classNames({ 'p-error': isFormFieldValid('celular') })}
                                >
                                    Celular
                                </label>

                                {
                                    !isLoading ?
                                        <InputMask
                                            id="celular"
                                            name="celular"
                                            unmask={true}
                                            value={formik.values.celular}
                                            mask={formik.values.celular !== undefined && formik.values.celular.length <= 10 ? "(99) 9999-9999?9" : "(99) 99999-9999"}
                                            onChange={formik.handleChange}
                                            className={classNames({ 'p-invalid': isFormFieldValid('celular') })}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.celular && formik.touched.celular &&
                                    <ErrorValidationMessage message={formik.errors.celular} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-4 p-md-2">
                                <label
                                    htmlFor="tipoId"
                                    className={classNames({ 'p-error': isFormFieldValid('tipoId') })}
                                >
                                    Tipo Pessoa
                                </label>
                                {
                                    !isLoading ?
                                        <Dropdown
                                            
                                            id="tipoId"
                                            name="tipoId"
                                            options={pessoasTipo}
                                            filter={true}
                                            emptyMessage={"Nenhum tipo de pessoa encontrado"}
                                            optionLabel="descricao"
                                            optionValue="id"
                                            placeholder="Selecione um tipo"                                            
                                            className={classNames({ 'p-invalid': isFormFieldValid('tipoId') })}
                                            value={formik.values.tipoId}
                                            onChange={option => formik.setFieldValue("tipoId", option.value)}
                                            emptyFilterMessage={"Nenhum tipo encontrado"}
                                            disabled={pessoasTipo === ''}

                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.tipoId && formik.touched.tipoId &&
                                    <ErrorValidationMessage message={formik.errors.tipoId} />
                                }
                            </div>  

                            <div className="p-field p-col-12 p-sm-8 p-md-5 p-xl-4">
                                <label
                                    htmlFor="observacao"
                                    className={classNames({ 'p-error': isFormFieldValid('observacao') })}
                                >
                                    Observação
                                </label>
                                {
                                    !isLoading ?
                                        <InputTextarea 
                                            rows={5} 
                                            cols={30}
                                            id="observacao"
                                            name="observacao"
                                            className={classNames({ 'p-invalid': isFormFieldValid('observacao') })}
                                            value={formik.values.observacao}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.observacao && formik.touched.observacao &&
                                    <ErrorValidationMessage message={formik.errors.observacao} />
                                }

                            </div>                         
                            

                        </div>
                    </form>
                </div>
            </div>

            <div className="p-d-flex p-justify-center p-mt-4">
                {
                    !isLoading ?
                        <Button
                            label={isEditing ? 'Editar' : 'Cadastrar'}
                            type="button"
                            loading={isSubmiting}
                            onClick={formik.handleSubmit}
                            style={{ width: '250px' }}
                        />
                        :
                        <Skeleton height="35px" />
                }
            </div>
        </>
    );
}
